/**
 * Login Page
 * Uses shadcn/ui components for consistent styling
 */

import { useState } from 'react';
import { useLogin } from '@/hooks/useAuth';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Alert, AlertDescription } from '@/components/ui/alert';

export function LoginPage() {
    const login = useLogin();
    const [email, setEmail] = useState('admin@example.com');
    const [password, setPassword] = useState('');

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        login.mutate({ email, password });
    };

    return (
        <form onSubmit={handleSubmit} className="space-y-4">
            {login.error && (
                <Alert variant="destructive">
                    <AlertDescription>
                        {login.error instanceof Error ? login.error.message : 'An error occurred'}
                    </AlertDescription>
                </Alert>
            )}

            <div className="space-y-2">
                <Label htmlFor="email">Email</Label>
                <Input
                    id="email"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    autoComplete="email"
                    placeholder="admin@example.com"
                />
            </div>

            <div className="space-y-2">
                <Label htmlFor="password">Password</Label>
                <Input
                    id="password"
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    autoComplete="current-password"
                    placeholder=""
                />
            </div>

            <Button
                type="submit"
                disabled={login.isPending}
                className="w-full"
            >
                {login.isPending ? 'Signing in...' : 'Sign In'}
            </Button>
        </form>
    );
}
